module.exports = __webpack_public_path__ + "static/media/outgoing-call.6585bec7.svg";